const classNames = require("classnames");
const { useConfig } = require("components/ui");
const { default: CheckboxGroupContext } = require("components/ui/Checkbox/context");
const { useInputGroup } = require("components/ui/InputGroup/context");
const { CONTROL_SIZES } = require("components/ui/utils/constant");
const { useContext } = require("react");
const { useForm } = require("react-hook-form");

export default function Helper() {
  const { themeColor, controlSize, primaryColorLevel } = useConfig();
  const { color: colorContext } = useContext(CheckboxGroupContext);
  const formControlSize = useForm()?.size;
  const inputGroupSize = useInputGroup()?.size;
  const inputSize = inputGroupSize || formControlSize || controlSize;

  const inputDefaultClass = "input";
  const inputSizeClass = `input-${inputSize} h-${CONTROL_SIZES[inputSize]}`;
  const inputFocusClass = `focus:ring-${themeColor}-${primaryColorLevel} focus-within:ring-${themeColor}-${primaryColorLevel} focus-within:border-${themeColor}-${primaryColorLevel} focus:border-${themeColor}-${primaryColorLevel}`;

  const checkboxColor = colorContext || `${themeColor}-${primaryColorLevel}`;

  const checkboxDefaultClass = `
  checkbox 
  accent-black
  text-${checkboxColor}
`;
  const checkBoxClass = classNames(checkboxDefaultClass);
  return {
    inputSize,
    inputDefaultClass,
    inputSizeClass,
    inputFocusClass,
    checkBoxClass
  }
}

